<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Update Employee Attendance Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><b>Employee List</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><b>Date</b></p>
                        <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="fromdate && employee">
                    <v-btn color="warning" @click="fetchEmployeeAttendanceDetails()">Fetch Attendance Details</v-btn>
                </v-row>
                <br />
            </v-card>
            <!-- <v-card class="box" v-if="employee_attendance_details.length > 0">
        <v-data-table :headers="headers" :items="employee_attendance_details">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Attendance Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isweeklyoff`]="{ item }">
            <span v-if="!item.freezeattendance">
              <v-switch
                v-model="item.isweeklyoff"
                @change="saveUpdateWeeklyOff(item)"
              ></v-switch>
            </span>
            <span v-else>Cannot Update As Attendance Is Freezed.</span>
          </template>
          <template v-slot:[`item.isnonworkingday`]="{ item }">
            <span v-if="!item.freezeattendance">
              <v-switch
                v-model="item.isnonworkingday"
                @change="saveIsnonWorkingDay(item)"
              ></v-switch>
            </span>
            <span v-else>Cannot Update As Attendance Is Freezed.</span>
          </template>
          <template v-slot:[`item.freezeattendance`]="{ item }">
            <span v-if="item.freezeattendance">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-switch
                v-model="item.freezeattendance"
                @change="saveFreezeUnfreezeAttendance(item)"
              ></v-switch>
            </span>
          </template>
          <template v-slot:[`item.intime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.intime"
            ></v-text-field>
          </template>
          <template v-slot:[`item.outtime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.outtime"
            ></v-text-field>
          </template>
          <template v-slot:[`item.expectedintime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.expectedintime"
            ></v-text-field>
          </template>
          <template v-slot:[`item.expectedouttime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.expectedouttime"
            ></v-text-field>
          </template>
          <template v-slot:[`item.delete_holiday`]="{ item }">
            <span v-if="item.holidaydetails != 'NA'">
              <span v-if="!item.freezeattendance">
                <v-avatar size="35">
                  <v-icon
                    class="mr-4 v-icon-size"
                    color="red"
                    @click="deleteHoliday(item)"
                    >mdi-trash-can</v-icon
                  >
                </v-avatar>
              </span>
              <span v-else>--</span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:[`item.update`]="{ item }">
            <span v-if="!item.freezeattendance">
              <v-btn
                color="green"
                @click="updateEmployeeAttendanceDetails(item)"
                >Update</v-btn
              >
            </span>
            <span v-else>Cannot Update As Attendance Is Freezed.</span>
          </template>
        </v-data-table>
      </v-card> -->

            <!-- new ui code  -->
            <v-card class="box" flat v-if="employee_attendance_details !=''"
                v-for="(i, n) in employee_attendance_details" :key="n">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Attendance Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-row dense justify="center">
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field rounded outlined color="#0F2027" flat dense v-model="i.name" name="emp_name"
                            label="Employee Name" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field rounded outlined color="#0F2027" flat dense v-model="i.employeetype"
                            name="employeetype" label="Employee Type" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field rounded outlined color="#0F2027" flat dense v-model="i.employeepaymentsection"
                            name="employeepaymentsection" label="Employee Section " readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <b>Is Attendance Freezed : </b>
                        <span v-if="i.freezeattendance">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </v-col>
                    <!-- </v-row>
                <v-row dense justify="center"> -->
                    <v-col cols="12" sm="3" md="3">
                        <b> Applied for leave : </b>
                        <span v-if="i.hasappliedforleavefortoday">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <b>Leave Approval Status : </b>
                        <span v-if="i.hasappliedforleavefortoday">
                            {{ i.leaveapprovalstatus }}
                        </span>
                        <span v-else>--</span>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <b>Leave Type : </b>
                        <span v-if="i.hasappliedforleavefortoday">
                            {{ i.leavetype }}
                        </span>
                        <span v-else>--</span>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="i.leaveapprovalstatus != 'Cancelled' ">
                        <!-- dd{{ !i.hasappliedforleavefortoday }} <br />
            ss{{ i.hasappliedforleavefortoday }} <br />
            fre{{ !i.freezeattendance }} {{ i.freezeattendance }} -->
                        <v-btn v-if="i.hasappliedforleavefortoday" :disabled="!i.freezeattendance ? false : true"
                            @click="removeLeave(i)">
                            <v-icon class="mr-4 v-icon-size" color="red">mdi-comment-remove-outline</v-icon>
                            Cancel Leave
                        </v-btn>
                    </v-col>
                    <!-- </v-row>
                <v-row dense justify="center"> -->
                    <v-col cols="12" sm="3" md="3"> <b> Expected No Of Hours : </b>{{ i.expectednoofhours }} </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <!-- <b> Is Non Working Day: </b> -->
                        <!-- <span v-if="!i.freezeattendance"> -->
                        <v-switch :disabled="i.freezeattendance" label="Is Non Working Day " v-model="i.isnonworkingday"
                            @change="saveIsnonWorkingDay(i)"></v-switch>
                        <!-- </span> -->
                        <!-- <span v-else>Cannot Update As Attendance Is Freezed.</span> -->
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-switch label="Is Weekly Off" v-model="i.isweeklyoff"
                            @change="saveUpdateWeeklyOff(i)"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <b>Holiday : </b>
                        <span>{{ i.holidaydetails }}</span>
                        <v-avatar size="35">
                            <v-icon class="ml-5 v-icon-size" color="red" @click="deleteHoliday(i)"
                                :disabled=" i.holidaydetails != 'NA' && !i.freezeattendance ? false : true">
                                mdi-trash-can
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <!-- {{i.remark}} -->
                        <v-text-field rounded outlined color="#0F2027" :disabled="i.freezeattendance" flat dense
                            v-model="i.remark" label="Remark"></v-text-field>

                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="3" md="3">
                        <b>Expected Intime</b>
                        <input id="expectedintime" type="time" v-model="i.expectedintime"
                            :disabled="!i.freezeattendance ? false : true" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <b>Intime</b>
                        <input id="intime" type="time" v-model="i.intime"
                            :disabled="!i.freezeattendance ? false : true" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn :disabled="!i.freezeattendance ? false : true" class="button mt-5"
                            @click="clearIntime(i)">Clear Intime</v-btn>
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="3" md="3">
                        <b>Expected Outtime</b>
                        <input id="expectedouttime" type="time" v-model="i.expectedouttime"
                            :disabled="!i.freezeattendance ? false : true" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <b>Outtime</b>
                        <input id="intime" type="time" v-model="i.outtime"
                            :disabled="!i.freezeattendance ? false : true" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn :disabled="!i.freezeattendance ? false : true" class="button mt-5"
                            @click="clearOutTime(i)">Clear Outtime</v-btn>
                    </v-col>
                </v-row>

                <!-- <v-row dense justify="center">
                    <v-col cols="12" sm="12" md="8">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="4">
                                <b> Is Non Working Day: &nbsp;&nbsp;</b>
                            </v-col>
                            <v-col cols="12" sm="6" md="8">
                                <span v-if="!i.freezeattendance">
                                    <v-switch v-model="i.isnonworkingday" @change="saveIsnonWorkingDay(i)"></v-switch>
                                </span>
                                <span v-else>Cannot Update As Attendance Is Freezed.</span>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row> -->
                <!-- <v-row dense justify="center">
                    <v-col cols="12" sm="4" md="4"> -->
                <!-- <b> Is Weeklyoff &nbsp;&nbsp;</b> -->
                <!-- <span v-if="i.isweeklyoff"> -->
                <!-- <v-switch v-model="i.isweeklyoff" @change="saveUpdateWeeklyOff(i)"></v-switch> -->
                <!-- </span> -->
                <!-- <span v-else>
               <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon>
            </span>  -->
                <!-- <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span> -->
                <!-- </v-col>
                </v-row> -->
                <!-- <v-row dense justify="center">
                    <v-col cols="12" sm="4" md="4">
                        <b>Holiday: &nbsp;&nbsp;&nbsp;</b>
                        <span>{{ i.holidaydetails }}</span>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-avatar size="35">
                            <v-icon
                                class="mr-4 v-icon-size"
                                color="red"
                                @click="deleteHoliday(i)"
                                :disabled="
                  i.holidaydetails != 'NA' && !i.freezeattendance ? false : true
                "
                            >
                                mdi-trash-can
                            </v-icon>
                        </v-avatar>
                    </v-col>
                </v-row> -->
                <v-row dense justify="center" v-if="!i.freezeattendance">
                    <v-col cols="12" sm="6" md="4">
                        <v-checkbox v-model="i.freezeattendance" @change="saveFreezeUnfreezeAttendance(i)"
                            label="Do you want to freeze attendance?"></v-checkbox>
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <span v-if="!i.freezeattendance">
                        <v-btn class="button" @click="updateEmployeeAttendanceDetails(i)">Update</v-btn>
                    </span>
                    <span v-else>Cannot Update As Attendance Is Freezed.</span>
                </v-row>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            employee_list: [],
            fromdate: new Date().toISOString().slice(0, 10),
            employee: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            show_detail_card: false,
            change_inout: false,
            employee_attendance_details: [],
            headers: [
                { text: "Sr No", value: "count" },
                { text: "Employee", value: "name" },
                { text: "Employee Type", value: "employeetype" },
                { text: "Section", value: "employeepaymentsection" },
                { text: "Expected Intime", value: "expectedintime" },
                { text: "Expected Outtime", value: "expectedouttime" },
                { text: "Expected No Of Hours", value: "expectednoofhours" },
                { text: "Intime", value: "intime" },
                { text: "Outtime", value: "outtime" },
                { text: "Is Non Working Day", value: "isnonworkingday" },
                { text: "Is Weeklyoff", value: "isweeklyoff" },
                { text: "Holiday", value: "holidaydetails" },
                { text: "Delete Holiday", value: "delete_holiday" },
                { text: "Is Attendance Freezed?", value: "freezeattendance" },
                { text: "Update", value: "update" },
            ],
        }),
        methods: {
            removeLeave(item) {
                const data = {
                    employee_attendance_id: item.id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/removeLeave", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Leave Removed Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            clearIntime(item) {
                console.log("clear Intime");
                console.log(item.id);
                const data = {
                    employee_attendance_id: item.id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/clearIntime", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            clearOutTime(item) {
                const data = {
                    employee_attendance_id: item.id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/clearOutTime", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            saveFreezeUnfreezeAttendance(item) {
                const data = {
                    employee_attendance_id: item.id,
                    employee_attendance_freezeattendance: item.freezeattendance,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveFreezeUnfreezeAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            saveIsnonWorkingDay(item) {
                const data = {
                    employee_attendance_id: item.id,
                    employee_attendance_isnonworkingday: item.isnonworkingday,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveIsnonWorkingDay", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },

            deleteHoliday(item) {
                const data = {
                    holidays: item.holiday_id,
                    instructors: item.instructor_id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/deleteHolidays", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Updated Successfully...");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        // this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.fetchEmployeeAttendanceDetails();
                    });
            },
            updateEmployeeAttendanceDetails(item) {
                const data = {
                    employee_attendance: item,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/updateEmployeeAttendanceDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            saveUpdateWeeklyOff(item) {
                if (item.freezeattendance == true) {
                    this.showSnackbar("red", "Cannot Update As Attendance Is Freezed..");
                    return;
                }
                //return
                const data = {
                    employee_attendance_id: item.id,
                    employee_attendance_weeklyoff: item.isweeklyoff,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveUpdateWeeklyOff", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            fetchEmployeeAttendanceDetails() {
                const data = {
                    employee: this.employee,
                    fromdate: this.fromdate,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/fetchEmployeeAttendanceDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.change_inout = res.data.change_inout;
                            this.show_detail_card = true;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.master_present = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            onLoad() {
                this.overlay = true;
                this.loader = true;
                axios
                    .post("/EmployeeBiometric/upateEmployeeAttendanceDetailsHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.employee_list;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    input[type="time"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
        color: #0f2027;
    }

    /* css for switch  */
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 4px;
    }
</style>
